import { defineMessages } from 'react-intl';
const i18nKey = 'SharedFooter.linkTitles';
const titleMessages = defineMessages({
  institutional: {
    id: `${i18nKey}.institutional`,
    defaultMessage: 'Solutions for institutional investors',
    description: `
    #Component: LEGACY
    #CharLimit: 80
    #Context: Institutional link title (CharLimit autocalculated to 80)`
  },
  commerce: {
    id: `${i18nKey}.commerce`,
    defaultMessage: 'Coinbase Commerce - Start accepting cryptocurrency payments',
    description: `
    #Component: LEGACY
    #CharLimit: 110
    #Context: Commerce link title (CharLimit autocalculated to 110)`
  },
  prime: {
    id: `${i18nKey}.prime`,
    defaultMessage: 'Prime - Integrated trading, finance, and custody',
    description: `
    #Component: LEGACY
    #CharLimit: 80
    #Context: Prime link title (CharLimit autocalculated to 80)`
  },
  listings: {
    id: `${i18nKey}.listings`,
    defaultMessage: 'Asset Listings - List your asset on Coinbase',
    description: `
    #Component: LEGACY
    #CharLimit: 70
    #Context: Listings link title`
  },
  wallet: {
    id: `${i18nKey}.wallet`,
    defaultMessage: 'Coinbase Wallet - Store your cryptocurrency',
    description: `
    #Component: LEGACY
    #CharLimit: 85
    #Context: Wallet link title (CharLimit autocalculated to 85)`
  },
  card: {
    id: `${i18nKey}.card`,
    defaultMessage: 'Coinbase Card',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Card link title (CharLimit autocalculated to 45)`
  },
  explore: {
    id: `${i18nKey}.explore`,
    defaultMessage: 'Explore',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Explore page title (CharLimit autocalculated to 40)`
  },
  // 2023-10-05: TODO please fix, see go/i18n-linter-messages
  // eslint-disable-next-line @cbhq/i18n-enhanced-description
  bytes: {
    id: `${i18nKey}.bytes`,
    defaultMessage: '{productName} newsletter',
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: Coinbase Bytes crypto newsletter title (CharLimit autocalculated to 60)`
  },
  cryptoBasics: {
    id: `${i18nKey}.cryptoBasics`,
    defaultMessage: 'Crypto basics',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Crypto basics page title (CharLimit autocalculated to 45)`
  },
  tipsAndTutorials: {
    id: `${i18nKey}.tipsAndTutorials`,
    defaultMessage: 'Tips & tutorials',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Tips & tutorials page title (CharLimit autocalculated to 50)`
  },
  cryptoGlossary: {
    id: `${i18nKey}.cryptoGlossary`,
    defaultMessage: 'Crypto glossary',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Crypto glossary page title (CharLimit autocalculated to 50)`
  },
  marketUpdates: {
    id: `${i18nKey}.marketUpdates`,
    defaultMessage: 'Market updates',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Market updates page title (CharLimit autocalculated to 50)`
  },
  whatIsBlockchain: {
    id: `${i18nKey}.whatIsBlockchain`,
    defaultMessage: 'What is a blockchain?',
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: Learn page title (CharLimit autocalculated to 60)`
  },
  whatIsBitcoin: {
    id: `${i18nKey}.whatIsBitcoin`,
    defaultMessage: 'What is Bitcoin?',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Learn page title (CharLimit autocalculated to 50)`
  },
  whatIsCrypto: {
    id: `${i18nKey}.whatIsCrypto`,
    defaultMessage: 'What is crypto?',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Learn page title (CharLimit autocalculated to 50)`
  },
  howToSetUpACryptoWallet: {
    id: `${i18nKey}.howToSetUpACryptoWallet`,
    defaultMessage: 'How to set up a crypto wallet',
    description: `
    #Component: LEGACY
    #CharLimit: 70
    #Context: How to set up a crypto wallet page title (CharLimit autocalculated to 70)`
  },
  howToSendCrypto: {
    id: `${i18nKey}.howToSendCrypto`,
    defaultMessage: 'How to send crypto',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: How to send crypto page title (CharLimit autocalculated to 55)`
  },
  buyAndSell: {
    id: `${i18nKey}.buyAndSell`,
    defaultMessage: 'Buy & sell',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Dashboard page title (CharLimit autocalculated to 45)`
  },
  earnFreeCrypto: {
    id: `${i18nKey}.earnFreeCrypto`,
    defaultMessage: 'Earn free crypto',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Rewards page title (CharLimit autocalculated to 50)`
  },
  supportedCountries: {
    id: `${i18nKey}.supportedCountries`,
    defaultMessage: 'Countries where Coinbase operates',
    description: `
    #Component: LEGACY
    #CharLimit: 75
    #Context: Supported Countires link title (CharLimit autocalculated to 75)`
  },
  status: {
    id: `${i18nKey}.status`,
    defaultMessage: 'Check the operational status of Coinbase services',
    description: `
    #Component: LEGACY
    #CharLimit: 95
    #Context: Status link title (CharLimit autocalculated to 95)`
  },
  jpNews: {
    id: `${i18nKey}.jpNews`,
    defaultMessage: 'News - Coinbase',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Japan only news link title (CharLimit autocalculated to 50)`
  },
  taxes: {
    id: `${i18nKey}.taxes`,
    defaultMessage: '2019 Crypto Tax Guide',
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: Taxes link title (CharLimit autocalculated to 60)`
  },
  companyDescription: {
    id: `${i18nKey}.companyDescription`,
    defaultMessage: 'Learn more about the company description',
    description: `
    #Component: LEGACY
    #CharLimit: 85
    #Context: Coinbase KK company description (CharLimit autocalculated to 85)`
  },
  about: {
    id: `${i18nKey}.about`,
    defaultMessage: 'Learn more about the company',
    description: `
    #Component: LEGACY
    #CharLimit: 65
    #Context: About link title (CharLimit autocalculated to 65)`
  },
  affiliates: {
    id: `${i18nKey}.affiliates`,
    defaultMessage: 'Earn money becoming an affiliate',
    description: `
    #Component: LEGACY
    #CharLimit: 70
    #Context: Affiliates link title (CharLimit autocalculated to 70)`
  },
  careers: {
    id: `${i18nKey}.careers`,
    defaultMessage: 'Work at Coinbase',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Careers link title (CharLimit autocalculated to 50)`
  },
  press: {
    id: `${i18nKey}.press`,
    defaultMessage: 'In the news',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Press link title (CharLimit autocalculated to 45)`
  },
  legalPrivacy: {
    id: `${i18nKey}.legalPrivacy`,
    defaultMessage: 'Our privacy and legal policies',
    description: `
    #Component: LEGACY
    #CharLimit: 70
    #Context: Legal and Privacy link title (CharLimit autocalculated to 70)`
  },
  cookiePolicy: {
    id: `${i18nKey}.cookiePolicy`,
    defaultMessage: 'Our cookie policy',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Cookie policy link title (CharLimit autocalculated to 55)`
  },
  digitalAssetDisclosures: {
    id: `${i18nKey}.digitalAssetDisclosures`,
    defaultMessage: 'Digital Asset Disclosures',
    description: `
    #Component: LEGACY
    #CharLimit: 65
    #Context: Digital Asset Disclosures link title (CharLimit autocalculated to 65)`
  },
  modernSlaveryStatement: {
    id: `${i18nKey}.modernSlaveryStatement`,
    defaultMessage: 'CB Payments, Ltd Modern Slavery and Human Trafficking Statement',
    description: `
    #Component: LEGACY
    #CharLimit: 115
    #Context: UK Modern Slavery Statement link title (CharLimit autocalculated to 115)`
  },
  imprint: {
    id: `${i18nKey}.imprint`,
    defaultMessage: 'Imprint',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Imprint link title (CharLimit autocalculated to 40)`
  },
  cloud: {
    id: `${i18nKey}.cloud`,
    defaultMessage: 'Cloud',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Coinbase cloud link title (CharLimit autocalculated to 35)`
  },
  devPlatform: {
    id: `${i18nKey}.devPlatform`,
    defaultMessage: 'Developer Platform',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Developer Platform link title (CharLimit autocalculated to 55)`
  },
  stakingFooterLink: {
    id: `${i18nKey}.stakingFooterLink`,
    defaultMessage: 'Staking',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Staking link title (CharLimit autocalculated to 40)`
  },
  onrampFooterLink: {
    id: `${i18nKey}.onrampFooterLink`,
    defaultMessage: 'Onramp',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Onramp link title (CharLimit autocalculated to 40)`
  },
  waas: {
    id: `${i18nKey}.waas`,
    defaultMessage: 'Wallet as a Service',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: waas link title (CharLimit autocalculated to 55)`
  },
  embWallets: {
    id: `${i18nKey}.embWallets`,
    defaultMessage: 'Wallets',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Wallets link title (CharLimit autocalculated to 40)`
  },
  exchangeApi: {
    id: `${i18nKey}.exchangeApi`,
    defaultMessage: 'Exchange API',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Exchange link title (CharLimit autocalculated to 45)`
  },
  baseNode: {
    id: `${i18nKey}.baseNode`,
    defaultMessage: 'Base Node',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Base Node link title (CharLimit autocalculated to 40)`
  },
  coinbaseApp: {
    id: `${i18nKey}.coinbaseApp`,
    defaultMessage: 'Coinbase App',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Coinbase App cloud link title (CharLimit autocalculated to 45)`
  },
  commerceCloud: {
    id: `${i18nKey}.commerceCloud`,
    defaultMessage: 'Commerce',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Commerce cloud link title (CharLimit autocalculated to 40)`
  },
  base: {
    id: `${i18nKey}.base`,
    defaultMessage: 'Base',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Base cloud link title (CharLimit autocalculated to 35)`
  },
  bisonTrails: {
    id: `${i18nKey}.bisonTrails`,
    defaultMessage: 'Bison Trails',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Bison Trails cloud link title (CharLimit autocalculated to 45)`
  },
  walletSdk: {
    id: `${i18nKey}.walletSdk`,
    defaultMessage: 'Wallet SDK',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Wallet SDK cloud link title (CharLimit autocalculated to 45)`
  },
  rosetta: {
    id: `${i18nKey}.rosetta`,
    defaultMessage: 'Rosetta',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Rosetta cloud link title (CharLimit autocalculated to 40)`
  },
  usdc: {
    id: `${i18nKey}.usdc`,
    defaultMessage: 'USDC',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: USDC cloud link title (CharLimit autocalculated to 35)`
  },
  helpCenter: {
    id: `${i18nKey}.helpCenter`,
    defaultMessage: 'Our help center',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Help Center link title (CharLimit autocalculated to 50)`
  },
  contactUs: {
    id: `${i18nKey}.contactUs`,
    defaultMessage: 'Contact us',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Contact Us link title (CharLimit autocalculated to 45)`
  },
  createAccount: {
    id: `${i18nKey}.createAccount`,
    defaultMessage: 'Coinbase support article for creating an account',
    description: `
    #Component: LEGACY
    #CharLimit: 95
    #Context: Link title for Coinbase support article for creating an account (CharLimit autocalculated to 95)`
  },
  idVerification: {
    id: `${i18nKey}.idVerification`,
    defaultMessage: 'Coinbase support article for ID verification',
    description: `
    #Component: LEGACY
    #CharLimit: 90
    #Context: Link title for Coinbase support article for identity verification (CharLimit autocalculated to 90)`
  },
  accountInformation: {
    id: `${i18nKey}.accountInformation`,
    defaultMessage: 'Coinbase support article for account information',
    description: `
    #Component: LEGACY
    #CharLimit: 95
    #Context: Link title for Coinbase support article for account information (CharLimit autocalculated to 95)`
  },
  paymentMethods: {
    id: `${i18nKey}.paymentMethods`,
    defaultMessage: 'Coinbase support article for payment methods',
    description: `
    #Component: LEGACY
    #CharLimit: 90
    #Context: Link title for Coinbase support article for payment methods (CharLimit autocalculated to 90)`
  },
  accountAccess: {
    id: `${i18nKey}.accountAccess`,
    defaultMessage: 'Coinbase support article for account access',
    description: `
    #Component: LEGACY
    #CharLimit: 85
    #Context: Link title for Coinbase support article for account recovery (CharLimit autocalculated to 85)`
  },
  supportedCrypto: {
    id: `${i18nKey}.supportedCrypto`,
    defaultMessage: 'Coinbase support article for supported cryptocurrencies',
    description: `
    #Component: LEGACY
    #CharLimit: 105
    #Context: Link title for Coinbase support article for supported cryptocurrencies (CharLimit autocalculated to 105)`
  },
  blog: {
    id: `${i18nKey}.blog`,
    defaultMessage: 'The Coinbase Blog',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Blog link title (CharLimit autocalculated to 55)`
  },
  security: {
    id: `${i18nKey}.security`,
    defaultMessage: 'Security',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Coinbase security link title (CharLimit autocalculated to 40)`
  },
  x: {
    id: `${i18nKey}.x`,
    defaultMessage: 'Coinbase X account',
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: X link title (CharLimit autocalculated to 60)`
  },
  facebook: {
    id: `${i18nKey}.facebook`,
    defaultMessage: 'Coinbase Facebook page',
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: Facebook link title (CharLimit autocalculated to 60)`
  },
  youtube: {
    id: `${i18nKey}.youtube`,
    defaultMessage: 'Coinbase Youtube page',
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: Youtube link title (CharLimit autocalculated to 60)`
  },
  coinbaseLogo: {
    id: `${i18nKey}.coinbaseLogoAlt`,
    defaultMessage: 'Coinbase logo',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Alt text for our Coinbase logo featured in our footer (CharLimit autocalculated to 45)`
  },
  investors: {
    id: `${i18nKey}.investors`,
    defaultMessage: 'Investors',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Investors page link title (CharLimit autocalculated to 40)`
  },
  node: {
    id: `${i18nKey}.node`,
    defaultMessage: 'Node',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Node link title (CharLimit autocalculated to 35)`
  },
  participate: {
    id: `${i18nKey}.participate`,
    defaultMessage: 'Participate',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: participate link title (CharLimit autocalculated to 45)`
  },
  primeApi: {
    id: `${i18nKey}.primeApi`,
    defaultMessage: 'Prime API',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Prime API link title (CharLimit autocalculated to 40)`
  },
  coinbasePaySdk: {
    id: `${i18nKey}.coinbasePaySdk`,
    defaultMessage: 'Easy, secure fiat-to-crypto solution',
    description: `
    #Component: LEGACY
    #CharLimit: 80
    #Context: Coinbase Pay SDK link title (CharLimit autocalculated to 80)`
  },
  derivatives: {
    id: `${i18nKey}.derivatives`,
    defaultMessage: 'Derivatives Exchange - Spot markets for high-frequency trading',
    description: `
    #Component: LEGACY
    #CharLimit: 75
    #Context: Coinbase Derivatives link title (CharLimit autocalculated to 75)`
  },
  vendors: {
    id: `${i18nKey}.vendors`,
    defaultMessage: 'Vendors',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Coinbase Vendors link title (CharLimit autocalculated to 40)`
  },
  coinbaseOne: {
    id: `${i18nKey}.coinbaseOne`,
    defaultMessage: 'Coinbase One',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Coinbase One link title (CharLimit autocalculated to 45)`
  },
  buildOnchainApps: {
    id: `${i18nKey}.buildOnchainApps`,
    defaultMessage: 'OnchainKit',
    description: `#Component: Link
    #CharLimit: 10
    #Context: Link to external website titled OnchainKit`
  },
  exchange: {
    id: `${i18nKey}.exchange`,
    defaultMessage: 'Coinbase Exchange - Spot markets for high-frequency trading',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Exchange link title`
  },
  internationalExchange: {
    id: `${i18nKey}.internationalExchange`,
    defaultMessage: 'International Exchange - Access perpetual futures markets',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: International Exchange link title`
  },
  verifiedPools: {
    id: `${i18nKey}.verifiedPools`,
    defaultMessage: 'Verified Pools - Transparent, verified liquidity pools',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Verified Pools link title`
  },
  staking: {
    id: `${i18nKey}.staking`,
    defaultMessage: 'Staking - Explore staking across our products',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Staking link title`
  }
});
export { titleMessages };
//# sourceMappingURL=messages.js.map
